/*
 * The search results page, on InstantSearch.js v4.
 *
 * It renders the markup the page had under InstantSearch.js 2, class for class, so the theme's
 * stylesheets and the browser suite in shopify-theme-e2e keep applying. Every widget is built on
 * an InstantSearch connector; the search engine is chosen in search_core.js alone, which also
 * provides the shop context and the helpers this file shares with the header search.
 */
(function () {
  "use strict";

  var core = window.awSearch;
  if (!core || !window.instantsearch) return;
  var config = core.config;

  var container = document.querySelector(config.results_selector);
  if (!container) return;

  var instantsearch = window.instantsearch;
  var connectors = instantsearch.connectors;
  var INDEX_NAME = core.productsIndex;
  var HITS_PER_PAGE = config.products_full_results_hits_per_page;
  var GENRE_ATTRIBUTES = [
    "named_tags.genre_level1",
    "named_tags.genre_level2",
    "named_tags.genre_level3",
    "named_tags.genre_level4",
    "named_tags.genre_level5",
  ];
  var GENRE_SEPARATOR = " > ";

  var secondaryMarket = core.secondaryMarket;
  var urlPrefix = core.urlPrefix;

  var facets = config.facets;
  var facetTitles = {};
  facets.forEach(function (facet) {
    facetTitles[facet.name] = facet.title;
  });
  facetTitles[GENRE_ATTRIBUTES[0]] = "Genre";

  // How many values a list facet shows, and how many after "Mehr anzeigen".
  var FACET_LIMIT = 10;
  var FACET_SHOW_MORE_LIMIT = 40;

  // The authors the theme setting "Authors hidden from the author filter" keeps out of the
  // author filter, one name per line. Their books stay in the results, and a hidden name still
  // shows while it is selected, so it can be cleared.
  var AUTHOR_FACET = "named_tags.onix_contrib";
  var _filterKey = function (name) {
    return String(name).trim().toLowerCase();
  };
  // No prototype, so a name such as "constructor" is hidden only when listed.
  var hiddenAuthors = Object.create(null);
  String((window.awSearchSettings || {}).hiddenFilterAuthors || "")
    .split(/\r?\n/)
    .forEach(function (name) {
      if (_filterKey(name)) hiddenAuthors[_filterKey(name)] = true;
    });
  var hiddenAuthorCount = Object.keys(hiddenAuthors).length;

  // A facet's values as its list shows them, and whether it offers "Mehr anzeigen". The author
  // filter asks the engine for as many more values as it may hide (_facetWidget) and cuts the
  // list back to its usual length here. It decides on "Mehr anzeigen" itself: the engine's answer
  // is judged against the raised limit, so with fewer hidden authors in the results than listed
  // it would withhold the link while values beyond the tenth remain.
  var _listItems = function (facet, renderOptions) {
    if (facet.name !== AUTHOR_FACET || hiddenAuthorCount === 0) {
      return { shown: renderOptions.items, canToggleShowMore: renderOptions.canToggleShowMore };
    }
    var visible = renderOptions.items.filter(function (item) {
      return item.isRefined || !hiddenAuthors[_filterKey(item.label)];
    });
    return {
      shown: visible.slice(0, renderOptions.isShowingMore ? FACET_SHOW_MORE_LIMIT : FACET_LIMIT),
      canToggleShowMore:
        renderOptions.canToggleShowMore || (facet.type !== "menu" && visible.length > FACET_LIMIT),
    };
  };

  /* ---------- Small helpers ---------- */

  var _escape = core.escape;
  var _germanNumber = core.germanNumber;
  var _price = core.price;
  var _sizedImage = core.sizedImage;
  var _normalizeQuery = core.normalizeQuery;
  var _on = core.on;

  // InstantSearch escapes highlighted values and marks matches with <mark>; the stylesheet styles
  // .ais-highlight.
  var _highlighted = function (value) {
    return String(value || "")
      .replace(/<mark>/g, '<span class="ais-highlight">')
      .replace(/<\/mark>/g, "</span>");
  };

  var _highlightedList = function (field, separator) {
    if (!field) return "";
    var values = Array.isArray(field) ? field : [field];
    return values
      .map(function (entry) {
        return _highlighted(entry.value);
      })
      .join(separator);
  };

  /* ---------- Page skeleton ---------- */

  var _renderPage = function () {
    var facetBlocks = facets
      .map(function (facet) {
        return (
          '<div class="ais-facet-' +
          _escape(facet.type) +
          " ais-facet-" +
          _escape(facet.name) +
          '"></div>'
        );
      })
      .join("");
    container.innerHTML =
      '<div class="ais-page">' +
      '<div class="ais-facets-button">Filter anzeigen</div>' +
      '<div class="ais-facets">' +
      '<div class="ais-current-refined-values-container"></div>' +
      '<div id="hierarchical-categories" class=""></div>' +
      facetBlocks +
      "</div>" +
      '<div class="ais-block">' +
      '<div class="ais-input">' +
      '<div class="ais-input--label">Suche</div>' +
      '<div class="ais-search-box-container"></div>' +
      '<div class="ais-input-button"><div class="ais-clear-input-icon"></div></div>' +
      "</div>" +
      '<div class="ais-search-header">' +
      '<div class="ais-stats-container"></div>' +
      '<div class="ais-change-display">' +
      // The space between the two icons is what keeps them apart; the stylesheet adds none.
      '<span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span> ' +
      '<span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>' +
      "</div>" +
      "</div>" +
      '<div class="ais-hits-container ais-results-as-block"></div>' +
      "</div>" +
      '<div class="ais-pagination-container"></div>' +
      "</div>";
  };

  // The stylesheet lays the page out by the width the results get, not by the window's width.
  var _readjust = function () {
    var width = container.offsetWidth;
    var suffix = width < 400 ? "xs" : width < 800 ? "sm" : width < 1200 ? "md" : "lg";
    ["xs", "sm", "md", "lg"].forEach(function (size) {
      container.classList.toggle("ais-results-size-" + size, size === suffix);
    });
  };

  var _bindPageControls = function () {
    var button = container.querySelector(".ais-facets-button");
    var facetsPanel = container.querySelector(".ais-facets");
    button.addEventListener("click", function () {
      var shown = facetsPanel.classList.toggle("ais-facets__shown");
      button.textContent = shown ? "Filter ausblenden" : "Filter anzeigen";
    });

    var header = container.querySelector(".ais-search-header");
    var hitsContainer = container.querySelector(".ais-hits-container");
    _on(
      header,
      "click",
      ".ais-change-display-block, .ais-change-display-list",
      function (event, target) {
        var asList = target.classList.contains("ais-change-display-list");
        header
          .querySelector(".ais-change-display-block")
          .classList.toggle("ais-change-display-selected", !asList);
        header
          .querySelector(".ais-change-display-list")
          .classList.toggle("ais-change-display-selected", asList);
        hitsContainer.classList.toggle("ais-results-as-list", asList);
        hitsContainer.classList.toggle("ais-results-as-block", !asList);
      },
    );

    // A click anywhere on a result opens the book; links inside it keep their own target.
    _on(hitsContainer, "click", ".ais-hit", function (event, hit) {
      if (event.target.closest("a")) return;
      var variantId = hit.getAttribute("data-variant-id");
      window.location.href =
        urlPrefix +
        "/products/" +
        hit.getAttribute("data-handle") +
        (variantId ? "?variant=" + variantId : "");
    });
  };

  /* ---------- State changes outside a widget ---------- */

  var _withoutRefinements = function (uiState) {
    var current = uiState[INDEX_NAME] || {};
    var next = {};
    next[INDEX_NAME] = current.query ? { query: current.query } : {};
    return next;
  };

  var _clearRefinements = function () {
    search.setUiState(_withoutRefinements);
  };

  var _clearQuery = function () {
    search.setUiState(function (uiState) {
      var next = Object.assign({}, uiState);
      next[INDEX_NAME] = Object.assign({}, uiState[INDEX_NAME]);
      delete next[INDEX_NAME].query;
      delete next[INDEX_NAME].page;
      return next;
    });
  };

  /* ---------- Widgets ---------- */

  var _searchBox = connectors.connectSearchBox(function (renderOptions, isFirstRender) {
    var root = container.querySelector(".ais-search-box-container");
    var clearIcon = container.querySelector(".ais-clear-input-icon");
    if (isFirstRender) {
      root.innerHTML =
        '<div class="ais-search-box"><input autocapitalize="off" autocomplete="off" autocorrect="off" ' +
        'placeholder="🔍 Titel, Autor:in, Verlag, ISBN.." role="textbox" spellcheck="false" type="text" ' +
        'class="ais-search-box--input" aria-label="Textfeld für Suche"></div>';
      var input = root.querySelector("input");
      input.value = renderOptions.query;
      input.addEventListener("input", function () {
        renderOptions.refine(_normalizeQuery(input.value));
      });
      clearIcon.addEventListener("click", function () {
        input.value = "";
        renderOptions.refine("");
        input.focus();
      });
    }
    var box = root.querySelector("input");
    // The box keeps what the customer typed, hyphens included; it only follows the query when the
    // query was changed elsewhere, as by the zero-result links.
    if (document.activeElement !== box && _normalizeQuery(box.value) !== renderOptions.query) {
      box.value = renderOptions.query;
    }
    clearIcon.style.display = renderOptions.query ? "block" : "none";
  });

  var _stats = connectors.connectStats(function (renderOptions, isFirstRender) {
    // The first render comes before any answer; the count line appears with the results, and the
    // browser suite waits for it as the sign that they are in.
    if (isFirstRender) return;
    var root = container.querySelector(".ais-stats-container");
    var nbHits = renderOptions.nbHits;
    var text;
    if (nbHits === 0) {
      text = "Keine Ergebnisse gefunden";
    } else if (nbHits === 1) {
      text = '<span class="ais-stats--nb-results">1 Ergebnis gefunden</span>';
    } else {
      var start = renderOptions.page * renderOptions.hitsPerPage + 1;
      var end = Math.min((renderOptions.page + 1) * renderOptions.hitsPerPage, nbHits);
      text =
        start +
        "-" +
        end +
        " von " +
        (core.countIsEstimated(renderOptions.query) ? "ca. " : "") +
        '<span class="ais-stats--nb-results">' +
        _germanNumber(nbHits) +
        " gefundenen Ergebnissen</span>";
    }
    root.innerHTML =
      '<div><div class="ais-root ais-stats"><div class="ais-body ais-stats--body"><div>' +
      text +
      "</div></div></div></div>";
  });

  // The price, and a crossed-out price with its discount only while the compare-at price is higher.
  // The percentage is worked out in whole cents: in floating point a 20% sale on 10 € reads -19%.
  var _priceMarkup = function (price, compareAtPrice) {
    var markup = "<b>" + _price(price) + "</b>";
    var priceCents = Math.round(Number(price) * 100);
    var compareAtCents = Math.round(Number(compareAtPrice) * 100);
    if (compareAtCents > priceCents) {
      var percent = Math.floor(((compareAtCents - priceCents) * 100) / compareAtCents);
      markup +=
        ' <span class="ais-hit--price-striked"><span>' +
        _price(compareAtPrice) +
        "</span></span> " +
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(percent / 10) * 100 +
        ';">-' +
        percent +
        "%</span>";
    }
    return markup;
  };

  var _hitMarkup = function (hit) {
    var tags = hit.named_tags || {};
    var highlight = hit._highlightResult || {};
    var highlightedTags = highlight.named_tags || {};
    var hasVariants = hit.variants_count > 1;
    var canOrder = hit.inventory_policy === "continue" || hit.inventory_quantity > 0;
    var isPreorder =
      typeof tags.wholesaler_note === "string" &&
      tags.wholesaler_note.indexOf("Jetzt vorbestellen") !== -1;
    var productUrl = urlPrefix + "/products/" + hit.handle;
    var variantUrl = productUrl + "?variant=" + hit.objectID;

    var contributors = "";
    if (tags["prod-version"] === "v3.0")
      contributors = _highlightedList(highlightedTags.onix_contrib_author, ", ");
    else if (tags["prod-version"] === "v2.1")
      contributors = _highlightedList(highlightedTags.onix_contrib, ", ");
    // An empty subtitle keeps its height; without it Safari lays the details out taller.
    var subtitle = contributors
      ? '<p class="ais-hit--subtitle">' + contributors + "</p>"
      : '<p class="ais-hit--subtitle" style="color:white">.</p>';

    var price = _priceMarkup(hit.price, hit.compare_at_price);
    // Until the market's own prices arrive, a secondary market shows no price rather than a wrong one.
    var priceStyle = secondaryMarket ? ' style="display: none;"' : "";

    var cartButton = hasVariants
      ? '<a class="ais-hit--cart-button" href="' +
        _escape(variantUrl) +
        '" id="' +
        _escape(hit.objectID) +
        '">Format Wählen</a>'
      : '<a class="ais-hit--cart-button" id="' +
        _escape(hit.objectID) +
        '" onclick="ajaxAddToCart(this.id)">' +
        (isPreorder ? "Vorbestellen" : "Bestellen") +
        "</a>";

    return (
      '<div class="ais-hit ais-product" data-handle="' +
      _escape(hit.handle) +
      '" data-variant-id="' +
      _escape(hit.objectID) +
      '" data-product-id="' +
      _escape(hit.id) +
      '">' +
      '<div class="ais-hit--picture lazyload" data-bg="' +
      _escape(_sizedImage(hit.image, "medium")) +
      '"></div>' +
      '<div class="ais-hit--details">' +
      '<p class="ais-hit--title"><a href="' +
      _escape(variantUrl) +
      '" title="' +
      _escape(hit.title) +
      '">' +
      _highlighted(highlight.title && highlight.title.value) +
      "</a></p>" +
      subtitle +
      '<p class="ais-hit--subtitle publisher">' +
      (tags.publisher
        ? _highlighted(highlightedTags.publisher && highlightedTags.publisher.value)
        : "") +
      "</p>" +
      '<p class="ais-hit--subtitle isbn"' +
      (hasVariants ? ' style="display: none;"' : "") +
      ">" +
      (hit.sku ? _highlighted(highlight.sku && highlight.sku.value) : "") +
      "</p>" +
      '<p class="ais-hit--price"' +
      priceStyle +
      ">" +
      price +
      "</p>" +
      (hasVariants
        ? '<p class="ais-hit--subtitle format"><span class="icon icon-c-decor icon-stack"></span> ' +
          _escape(hit.variants_count) +
          " Formate verfügbar</p>"
        : '<p class="ais-hit--subtitle tag-format">' + _escape(tags.format) + "</p>") +
      '<p class="ais-hit--cart"' +
      (canOrder ? "" : ' style="visibility: hidden;"') +
      ">" +
      cartButton +
      "</p>" +
      "</div>" +
      "</div>"
    );
  };

  var _emptyMarkup = function (query) {
    return (
      '<div class="ais-hits ais-hits__empty"><div class="ais-hit-empty">' +
      '<div class="ais-hit-empty--title">Keine Suchergebnisse für "' +
      _escape(query) +
      '"</div>' +
      '<div class="ais-hit-empty--clears">' +
      '<a class="ais-hit-empty--clear-filters ais-link">Filter zurücksetzen</a> oder ' +
      '<a class="ais-hit-empty--clear-input ais-link">neuen Suchbegriff eingeben</a>' +
      "</div></div></div>"
    );
  };

  // Every render of the results asks Shopify about its products (search_core.js lookUpProducts); only
  // the answer to the latest request may touch the page, since typing re-renders while an earlier
  // answer is still on its way.
  var latestLookup = 0;

  var _showLiveData = function (root, hits, query) {
    var request = ++latestLookup;
    var productIds = hits.map(function (hit) {
      return String(hit.id);
    });
    core.lookUpProducts(productIds).then(function (products) {
      if (request !== latestLookup) return;
      // A failed request changes nothing; in a secondary market the prices stay hidden, which is no
      // price rather than a wrong one.
      if (products === null) return;
      root.querySelectorAll(".ais-hit").forEach(function (element) {
        var productId = element.getAttribute("data-product-id");
        if (productIds.indexOf(productId) === -1) return;
        var product = products[productId];
        // Removed rather than hidden: the stylesheet places results by their position in the list.
        if (!product) {
          element.closest(".ais-hits--item").remove();
          return;
        }

        // The price of the format the result links to; the lowest price, without a crossed-out one,
        // when Shopify no longer lists that format.
        var variant = product.variants[element.getAttribute("data-variant-id")];
        var shown = variant || { price: product.price, compareAtPrice: 0 };
        var priceElement = element.querySelector(".ais-hit--price");
        priceElement.innerHTML = _priceMarkup(shown.price, shown.compareAtPrice);
        priceElement.classList.add("algolia-price-updated");
        priceElement.style.display = "";

        // A single-format result's button adds the linked format to the cart, so it goes when
        // Shopify no longer lists that format; a multi-format result's link to the product page
        // stays. The lookup asks for ten formats; past that, a missing one may just not have been
        // asked for.
        var addsToCart = element.querySelector(".ais-hit--cart-button[onclick]") !== null;
        var formatGone = addsToCart && !variant && Object.keys(product.variants).length < 10;
        element.querySelector(".ais-hit--cart").style.visibility =
          product.available && !formatGone ? "" : "hidden";

        if (product.image) {
          var picture = element.querySelector(".ais-hit--picture");
          var cover = _sizedImage(product.image, "medium");
          picture.setAttribute("data-bg", cover);
          // Once the lazy loader has shown the record's cover, it no longer reads data-bg.
          if (picture.classList.contains("lazyloaded")) {
            picture.style.backgroundImage = "url(" + JSON.stringify(cover) + ")";
          }
        }
      });
      // Every result on the page is gone from the shop: say so rather than show an empty grid.
      if (!root.querySelector(".ais-hits--item")) {
        console.warn("Search: the shop has none of the products this page of results lists.");
        root.innerHTML = _emptyMarkup(query);
      }
    });
  };

  var lastRenderedResults = null;
  var _hits = connectors.connectHits(function (renderOptions, isFirstRender) {
    var root = container.querySelector(".ais-hits-container");
    if (isFirstRender) {
      _on(root, "click", ".ais-hit-empty--clear-filters", _clearRefinements);
      _on(root, "click", ".ais-hit-empty--clear-input", function () {
        var input = container.querySelector(".ais-search-box--input");
        input.value = "";
        _clearQuery();
        input.focus();
      });
    }
    var results = renderOptions.results;
    if (!results) return;
    // A search slower than InstantSearch's stall delay renders once more with the previous results;
    // redrawing them would undo the shop's answer and ask Shopify again.
    if (results === lastRenderedResults) return;
    lastRenderedResults = results;
    if (renderOptions.items.length === 0) {
      // A lookup still on its way for the previous results must not rewrite this page.
      latestLookup += 1;
      root.innerHTML = _emptyMarkup(results.query);
      return;
    }
    root.innerHTML =
      '<div class="ais-hits">' +
      renderOptions.items
        .map(function (hit) {
          return '<div class="ais-hits--item">' + _hitMarkup(hit) + "</div>";
        })
        .join("") +
      "</div>";
    _showLiveData(root, renderOptions.items, results.query);
  });

  var _facetHeader = function (widget, title) {
    return (
      '<div class="ais-' +
      widget +
      '--header ais-facet--header ais-header">' +
      _escape(title) +
      "</div>"
    );
  };

  // One renderer for the list facets: a value per line with its count; a click refines on it.
  var _listFacet = function (widget, facet) {
    var latest;
    return function (renderOptions, isFirstRender) {
      var root = container.querySelector('[class~="ais-facet-' + facet.name + '"]');
      if (!root) return;
      latest = renderOptions;
      if (isFirstRender) {
        _on(root, "click", ".ais-facet--item", function (event, item) {
          event.preventDefault();
          latest.refine(item.getAttribute("data-value"));
        });
        _on(root, "click", ".ais-show-more", function (event) {
          event.preventDefault();
          latest.toggleShowMore();
        });
      }
      var list = _listItems(facet, renderOptions);
      if (list.shown.length === 0) {
        root.innerHTML = "";
        return;
      }
      var items = list.shown
        .map(function (item) {
          var active = item.isRefined ? " ais-" + widget + "--item__active ais-facet--active" : "";
          var checkbox =
            facet.type === "disjunctive"
              ? '<input type="checkbox" class="ais-' +
                widget +
                '--checkbox ais-facet--checkbox"' +
                (item.isRefined ? " checked" : "") +
                "/>"
              : "";
          return (
            '<div class="ais-' +
            widget +
            "--item ais-facet--item" +
            active +
            '" data-value="' +
            _escape(item.value) +
            '"><div>' +
            '<label class="ais-' +
            widget +
            '--label ais-facet--label">' +
            checkbox +
            _escape(item.label) +
            ' <span class="ais-' +
            widget +
            '--count ais-facet--count">' +
            _germanNumber(item.count) +
            "</span></label>" +
            "</div></div>"
          );
        })
        .join("");
      var showMore = list.canToggleShowMore
        ? '<div><a class="ais-show-more ' +
          (renderOptions.isShowingMore
            ? 'ais-show-more__active">Weniger anzeigen'
            : 'ais-show-more__inactive">Mehr anzeigen') +
          "</a></div>"
        : "";
      root.innerHTML =
        '<div><div class="ais-root ais-' +
        widget +
        ' ais-facet">' +
        _facetHeader(widget, facet.title) +
        '<div class="ais-body ais-' +
        widget +
        '--body ais-facet--body"><div class="ais-' +
        widget +
        '--list">' +
        items +
        showMore +
        "</div></div></div></div>";
    };
  };

  var _facetWidget = function (facet) {
    if (facet.type === "slider") {
      var root = container.querySelector('[class~="ais-facet-' + facet.name + '"]');
      root.innerHTML =
        '<div><div class="ais-root ais-range-slider ais-facet">' +
        _facetHeader("range-slider", facet.title) +
        '<div class="ais-body ais-range-slider--body ais-facet--body"></div></div></div>';
      return instantsearch.widgets.rangeSlider({
        container: root.querySelector(".ais-range-slider--body"),
        attribute: facet.name,
        pips: false,
      });
    }
    var extra = facet.name === AUTHOR_FACET ? hiddenAuthorCount : 0;
    if (facet.type === "menu") {
      return connectors.connectMenu(_listFacet("menu", facet))({
        attribute: facet.name,
        limit: FACET_LIMIT + extra,
      });
    }
    // Both list types refine with AND, as the page always has; a disjunctive facet shows checkboxes.
    return connectors.connectRefinementList(_listFacet("refinement-list", facet))({
      attribute: facet.name,
      operator: "and",
      limit: FACET_LIMIT + extra,
      showMore: true,
      showMoreLimit: FACET_SHOW_MORE_LIMIT + extra,
    });
  };

  var _genreList = function (items, level, createURL) {
    return (
      '<div class="ais-hierarchical-menu--list ais-hierarchical-menu--list__lvl' +
      level +
      '">' +
      items
        .map(function (item) {
          var active = item.isRefined ? " ais-hierarchical-menu--item__active active" : "";
          return (
            '<div class="ais-hierarchical-menu--item ais-facet--item item' +
            active +
            '"><div>' +
            '<a class="ais-hierarchical-menu--link" href="' +
            _escape(createURL(item.value)) +
            '" data-value="' +
            _escape(item.value) +
            '">' +
            _escape(item.label) +
            ' <span class="ais-hierarchical-menu--count ais-facet--count">' +
            _germanNumber(item.count) +
            "</span></a>" +
            "</div>" +
            (item.data ? _genreList(item.data, level + 1, createURL) : "") +
            "</div>"
          );
        })
        .join("") +
      "</div>"
    );
  };

  var latestGenres;
  var _genres = connectors.connectHierarchicalMenu(function (renderOptions, isFirstRender) {
    var root = container.querySelector("#hierarchical-categories");
    latestGenres = renderOptions;
    if (isFirstRender) {
      _on(root, "click", ".ais-hierarchical-menu--link", function (event, link) {
        event.preventDefault();
        latestGenres.refine(link.getAttribute("data-value"));
      });
    }
    if (renderOptions.items.length === 0) {
      root.innerHTML = "";
      return;
    }
    root.innerHTML =
      '<div><div class="ais-root ais-hierarchical-menu ais-facet">' +
      _facetHeader("hierarchical-menu", "Genre") +
      '<div class="ais-body ais-hierarchical-menu--body ais-facet--body">' +
      _genreList(renderOptions.items, 0, renderOptions.createURL) +
      "</div></div></div>";
  });

  var _refinementLabel = function (item, refinement) {
    var title = facetTitles[item.attribute] || item.label;
    if (refinement.type === "numeric") return _escape(title) + " " + _escape(refinement.label);
    return _escape(title) + ": " + _escape(refinement.label);
  };

  var shownRefinements = [];
  var _currentRefinements = connectors.connectCurrentRefinements(
    function (renderOptions, isFirstRender) {
      var root = container.querySelector(".ais-current-refined-values-container");
      if (isFirstRender) {
        _on(root, "click", ".ais-current-refined-values--clear-all", function (event) {
          event.preventDefault();
          _clearRefinements();
        });
        _on(root, "click", ".ais-current-refined-values--link", function (event, link) {
          event.preventDefault();
          var entry = shownRefinements[Number(link.getAttribute("data-index"))];
          if (entry) entry.item.refine(entry.refinement);
        });
      }
      var refinements = [];
      renderOptions.items.forEach(function (item) {
        item.refinements.forEach(function (refinement) {
          refinements.push({ item: item, refinement: refinement });
        });
      });
      shownRefinements = refinements;
      if (refinements.length === 0) {
        root.innerHTML = "";
        return;
      }
      // The first render runs while the search is still starting, before it can build addresses.
      var clearAllUrl = isFirstRender
        ? "#"
        : search.createURL(_withoutRefinements(search.getUiState()));
      root.innerHTML =
        '<div><div class="ais-root ais-current-refined-values ais-facet">' +
        '<div class="ais-current-refined-values--header ais-facet--header ais-header">Filter</div>' +
        '<div class="ais-body ais-current-refined-values--body ais-facet--body"><div>' +
        '<a class="ais-current-refined-values--clear-all" href="' +
        _escape(clearAllUrl) +
        '"><div>⛌ Alle zurücksetzen</div></a>' +
        '<div class="ais-current-refined-values--list">' +
        refinements
          .map(function (entry, index) {
            return (
              '<div class="ais-current-refined-values--item"><a class="ais-current-refined-values--link" href="' +
              _escape(renderOptions.createURL(entry.refinement)) +
              '" data-index="' +
              index +
              '"><div>' +
              '<div class="ais-current-refined-values--label">' +
              _refinementLabel(entry.item, entry.refinement) +
              "</div>" +
              "</div></a></div>"
            );
          })
          .join("") +
        "</div></div></div></div></div>";
    },
  );

  var latestPagination;
  var _pagination = connectors.connectPagination(function (renderOptions, isFirstRender) {
    var root = container.querySelector(".ais-pagination-container");
    latestPagination = renderOptions;
    if (isFirstRender) {
      _on(root, "click", "a.ais-pagination--link", function (event, link) {
        event.preventDefault();
        latestPagination.refine(Number(link.getAttribute("data-page")));
        window.scrollTo(0, 0);
      });
    }
    if (renderOptions.nbHits === 0) {
      root.innerHTML = "";
      return;
    }
    var current = renderOptions.currentRefinement;
    var _item = function (kind, label, page, disabled, active) {
      var classes =
        "ais-pagination--item ais-pagination--item__" +
        kind +
        (disabled ? " ais-pagination--item__disabled" : "") +
        (active ? " ais-pagination--item__active" : "");
      var link = disabled
        ? '<span class="ais-pagination--link">' + label + "</span>"
        : '<a class="ais-pagination--link" aria-label="' +
          _escape(kind === "page" ? page + 1 : label) +
          '" href="' +
          _escape(renderOptions.createURL(page)) +
          '" data-page="' +
          page +
          '">' +
          label +
          "</a>";
      return '<li class="' + classes + '">' + link + "</li>";
    };
    var last = renderOptions.nbPages - 1;
    root.innerHTML =
      '<div><ul class="ais-pagination">' +
      _item("first", "«", 0, renderOptions.isFirstPage) +
      _item("previous", "‹", current - 1, renderOptions.isFirstPage) +
      renderOptions.pages
        .map(function (page) {
          return _item("page", String(page + 1), page, false, page === current);
        })
        .join("") +
      _item("next", "›", current + 1, renderOptions.isLastPage) +
      _item("last", "»", last, renderOptions.isLastPage) +
      "</ul></div>";
  });

  /* ---------- The address ---------- */

  // The page reads and writes the address format of the InstantSearch.js 2 page it replaces, so the
  // links on product pages and every address already shared keep working:
  //   q  p (0-based)  fR[attribute][i] (list facets)  hFR[attribute][0] (genre path, menus)
  //   nR[attribute][>=|<=][0] (sliders)  is_v=1
  // Parameters the page does not own, such as type=product, are kept.
  var OWN_PARAMETERS = ["q", "hPP", "idx", "p", "fR", "dFR", "hFR", "nR", "is_v"];

  var _stateToRoute = function (uiState) {
    var state = uiState[INDEX_NAME] || {};
    var route = {
      q: state.query || "",
      hPP: HITS_PER_PAGE,
      idx: INDEX_NAME,
      p: state.page ? state.page - 1 : 0,
    };
    var refinements = state.refinementList || {};
    if (Object.keys(refinements).length) route.fR = refinements;
    var hierarchical = {};
    var genrePath = state.hierarchicalMenu && state.hierarchicalMenu[GENRE_ATTRIBUTES[0]];
    if (genrePath && genrePath.length)
      hierarchical[GENRE_ATTRIBUTES[0]] = [genrePath.join(GENRE_SEPARATOR)];
    Object.keys(state.menu || {}).forEach(function (attribute) {
      hierarchical[attribute] = [state.menu[attribute]];
    });
    if (Object.keys(hierarchical).length) route.hFR = hierarchical;
    var numeric = {};
    Object.keys(state.range || {}).forEach(function (attribute) {
      var bounds = String(state.range[attribute]).split(":");
      var entry = {};
      if (bounds[0] !== "") entry[">="] = [bounds[0]];
      if (bounds[1] !== undefined && bounds[1] !== "") entry["<="] = [bounds[1]];
      if (Object.keys(entry).length) numeric[attribute] = entry;
    });
    if (Object.keys(numeric).length) route.nR = numeric;
    route.is_v = 1;
    return route;
  };

  var _routeToState = function (route) {
    var state = {};
    if (route.q) state.query = _normalizeQuery(route.q);
    var page = parseInt(route.p, 10);
    if (page > 0) state.page = page + 1;
    var lists = {};
    [route.fR, route.dFR].forEach(function (group) {
      Object.keys(group || {}).forEach(function (attribute) {
        var values = group[attribute];
        lists[attribute] = (lists[attribute] || []).concat(
          Array.isArray(values) ? values : Object.values(values),
        );
      });
    });
    if (Object.keys(lists).length) state.refinementList = lists;
    var menuAttributes = facets
      .filter(function (facet) {
        return facet.type === "menu";
      })
      .map(function (facet) {
        return facet.name;
      });
    Object.keys(route.hFR || {}).forEach(function (attribute) {
      var values = route.hFR[attribute];
      var value = Array.isArray(values) ? values[0] : Object.values(values)[0];
      if (!value) return;
      if (attribute === GENRE_ATTRIBUTES[0]) {
        state.hierarchicalMenu = {};
        state.hierarchicalMenu[attribute] = String(value).split(GENRE_SEPARATOR);
      } else if (menuAttributes.indexOf(attribute) !== -1) {
        state.menu = state.menu || {};
        state.menu[attribute] = value;
      }
    });
    Object.keys(route.nR || {}).forEach(function (attribute) {
      var bounds = route.nR[attribute] || {};
      var min = bounds[">="] ? [].concat(bounds[">="])[0] : "";
      var max = bounds["<="] ? [].concat(bounds["<="])[0] : "";
      state.range = state.range || {};
      state.range[attribute] = min + ":" + max;
    });
    var uiState = {};
    uiState[INDEX_NAME] = state;
    return uiState;
  };

  var routing = {
    router: instantsearch.routers.history({
      cleanUrlOnDispose: false,
      createURL: function (options) {
        var kept = options.qsModule.parse(options.location.search.slice(1));
        OWN_PARAMETERS.forEach(function (name) {
          delete kept[name];
        });
        var own = Object.assign({}, options.routeState);
        var isV = own.is_v;
        delete own.is_v;
        var parts = [
          options.qsModule.stringify(own, { encodeValuesOnly: true }),
          options.qsModule.stringify(kept, { encodeValuesOnly: true }),
          isV ? "is_v=" + isV : "",
        ].filter(Boolean);
        return (
          options.location.origin +
          options.location.pathname +
          "?" +
          parts.join("&") +
          options.location.hash
        );
      },
      parseURL: function (options) {
        return options.qsModule.parse(options.location.search.slice(1), { arrayLimit: 99 });
      },
    }),
    stateMapping: {
      stateToRoute: _stateToRoute,
      routeToState: _routeToState,
    },
  };

  /* ---------- Start ---------- */

  _renderPage();
  _readjust();
  window.addEventListener("resize", _readjust);
  _bindPageControls();

  var search = instantsearch({
    indexName: INDEX_NAME,
    searchClient: core.createSearchClient(),
    routing: routing,
    // The privacy policy promises no tracking.
    insights: false,
  });

  search.addWidgets(
    [
      instantsearch.widgets.configure({
        hitsPerPage: HITS_PER_PAGE,
        distinct: true,
        facetingAfterDistinct: false,
        // A search that finds nothing is run again with every word optional, so
        // a long phrase with one word we don't carry still finds the book;
        // results then rank by how many words they match.
        removeWordsIfNoResults: "allOptional",
      }),
      _searchBox({}),
      _stats({}),
      _currentRefinements({
        includedAttributes: facets
          .map(function (facet) {
            return facet.name;
          })
          .concat(GENRE_ATTRIBUTES[0]),
      }),
      _genres({
        attributes: GENRE_ATTRIBUTES,
        separator: GENRE_SEPARATOR,
        limit: 30,
        sortBy: ["count:desc", "name:asc"],
      }),
    ]
      .concat(facets.map(_facetWidget))
      .concat([
        // Highlighted values are inserted as HTML; they are safe because the connector escapes them.
        _hits({ escapeHTML: true }),
        _pagination({ padding: 2, totalPages: 20 }),
      ]),
  );

  search.start();
})();
